import { useState } from "react";
import { useSelector } from "react-redux";
import { ChangeUser } from "./ChangeUser";
import { ChangeUserPassword } from "./ChangeUserPassword";



export const UserModifyPage = ()=>{
    const [tab, setTab] = useState('user_info');
    const auth = useSelector(state => state.auth);

    if(!auth.authenticated)return null;
    return (
        <div className="user_modify_page">
            <div className="user_info show">
            <div className="modal_cont">
                <h2 className="title"><span className="icon">정보 수정</span></h2>
                <div className="modal_tab_area">
                    <ul className="tabs">
                        <li className={tab==='user_info'?'on':''} onClick={()=>setTab('user_info')}>기본정보</li>
                        <li className={tab==='password'?'on':''} onClick={()=>setTab('password')}>비밀번호</li>
                    </ul>

                    <ChangeUser active={tab==='user_info'} />
                    <ChangeUserPassword active={tab==='password'} />
                </div>
            </div>
        </div>
        </div>
    );
};